import { Skeleton } from "../ui/skeleton";

export const StackedELSkeletonLoader = ({ limit = 3 }: { limit?: number }) => (
  <div className="el-affiliate bg-gray-50 pb-6 relative max-w-4xl mx-auto animate-pulse">
    <section className="header-section h-full text-center flex flex-col px-6 border-2 bg-primary/10">
      <div className="mt-2 px-1 text-sm font-normal border w-fit rounded ml-auto mr-[-8px]">
        <Skeleton className="w-24 h-5" />
      </div>
      <Skeleton className="h-10 w-3/4 mx-auto my-4" />
      <Skeleton className="h-6 w-2/3 mx-auto mb-4" />
    </section>
    <div className="md:rounded-lg p-6 h-full flex flex-col gap-6 items-center">
      {Array.from({ length: limit }).map((_, i) => (
        <div
          key={i}
          className="card-container w-full border rounded-xl flex flex-col relative min-h-[216px] bg-white"
        >
          <div className="h-full p-5 flex flex-col md:flex-row-reverse md:justify-between">
            <div className="relative md:pl-5 flex flex-row md:flex-col flex-shrink-0 items-center gap-3 w-full md:w-1/4 flex-nowrap content-center justify-center">
              <Skeleton className="w-[120px] h-[65px] md:mb-3" />
              <div className="flex flex-row items-center justify-left w-full">
                <Skeleton className="h-10 w-full" />
              </div>
            </div>
            <div className="w-full md:mr-5">
              <Skeleton className="h-5 w-56 mb-2" />
              <Skeleton className="h-8 w-72 mt-2" />
              <div className="h-6 mt-3 flex flex-row gap-2 flex-wrap">
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-6 w-32" />
              </div>
              <div className="flex flex-col justify-between">
                <Skeleton className="h-16 w-full my-4" />
                <Skeleton className="h-10 w-full" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
